import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import { DepartmentsResponse, DepartmentRecruiterAdd, DepartmentRecruiterMove, DepartmentRecruiterRemove, DepartmentViewRequest, DepartmentViewResponse, DepartmentsRequest } from "./types";

export const departments = (data: DepartmentsRequest): AxiosPromise<DepartmentsResponse> =>
  axiosInstance
    .get(`/departments?expand=${data.params.expand?.join(",")}`, {
      params: {
        channel_id: data.params.channel_id,
        limit: data.params.limit,
        offset: data.params.offset,
      },
    })
    .then((res) => res.data);

export const departmentView = (data: DepartmentViewRequest): AxiosPromise<DepartmentViewResponse> =>
  axiosInstance.get(
    `/department/${data.params.id}/view?expand=${data.params.expand?.join(",")}`
  );

export const addRecruiter = (data: DepartmentRecruiterAdd): AxiosPromise<undefined> =>
  axiosInstance.post(`/department/${data.param.department_id}/add`, data.data);

export const moveRecruiter = (data: DepartmentRecruiterMove): AxiosPromise<undefined> =>
  axiosInstance.post(`/department/${data.param.department_id}/move`, data.data);

export const removeRecruiter = (data: DepartmentRecruiterRemove): AxiosPromise<undefined> =>
  axiosInstance.post(`/department/${data.param.department_id}/remove`, data.data);

